import { lazy } from 'react'

// reload가 네비게이션으로 이어지는 데 걸리는 최대 대기 시간. 이 시간 안에 페이지가 교체되지 않으면 원 에러를 던져 ErrorBoundary로 위임한다.
const RELOAD_FALLBACK_MS = 5000

const lazyRetry = (componentImport: any) =>
  lazy(async () => {
    const hasRefreshed = JSON.parse(window.sessionStorage.getItem('retryLazyRefreshed') || 'false')
    try {
      const component = await componentImport()
      window.sessionStorage.setItem('retryLazyRefreshed', 'false')
      return component
    } catch (error) {
      if (!hasRefreshed) {
        window.sessionStorage.setItem('retryLazyRefreshed', 'true')
        window.location.reload()
        // reload은 비동기이므로 그 사이 undefined에 .default 접근하는 크래시를 막기 위해 대기한다.
        // 정상 흐름에선 수백 ms 안에 페이지가 교체되고, 교체되지 않으면 ErrorBoundary로 넘긴다.
        await new Promise((resolve) => setTimeout(resolve, RELOAD_FALLBACK_MS))
      }
      throw error
    }
  })

export { lazyRetry }
